
import { defineComponent } from 'vue'

/**
 * A clickable label for a team. Links to the members settings page.
 */
export default defineComponent({
  name: 'TeamLabel',
  props: {
    login: {
      type: String,
      required: true
    },
    vcsProvider: {
      type: String,
      required: true
    }
  },
  computed: {
    settingsLink(): string {
      return `/${this.vcsProvider.toLowerCase()}/${this.login}/members/active`
    }
  }
})
